import VueRouter from "vue-router";
import EdithCdss from "../../../edith-cdss/src/EdithCdss.vue";
import cdssRoutes from "../../../edith-cdss/src/router/routes";
import EdithApp from "../../../edith-app/src/EdithApp.vue";
import appRoutes from "../../../edith-app/src/router";
import {isAuthenticated, logout} from "../js/util";

const router = new VueRouter({
    routes: [
        {
            path: '/cdss',
            component: EdithCdss,
            children: cdssRoutes,
            meta: {requiresAuth: true}
        },
        {
            path: '/app',
            alias: '/',
            component: EdithApp,
            children: appRoutes
        }
    ]
})

// Global guard
router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth && !isAuthenticated()) {
        logout();
        alert('You must be registered to access this page.');
        return next('/');
    }
    next();
});

export default router